<template>
    <ui-modal>
        <template #header>
            <h3 class="text-center" v-text="isSuccess ? 'Świetnie!' : 'Wystąpił błąd!'" />
        </template>

        <div class="text-center h5 font-weight-semi mb-3">
            <a-icon
                class="text-warning mb-3"
                width="40px"
                height="40px"
                :icon="isSuccess ? 'Ok' : 'ErrorCircle'"
            />
            <br />

            <template v-if="isSuccess">
                Rejestracja umowy z operatorem {{ operator.name }} przebiegła pomyślnie.<br />
                Możesz teraz wybrać sklepy objęte umową lub zrobić to później w ramach edycji umowy.
            </template>
            <template v-else>
                Rejestracja umowy nie powiodła się. Spróbuj ponownie lub wyślij wiadomość
                <a href="mailto:pomoc@kaucyjni.pl">pomoc@kaucyjni.pl</a>
            </template>

        </div>
        <template #footer>
            <the-btn
                text="Zamknij"
                class="btn-outline-custom"
                @click="$emit('close-modal')"
            />
            <the-btn
                :text="isSuccess ? 'Przejdź do wyboru sklepów' : 'Spróbuj ponownie'"
                class="btn-secondary"
                @click="onCtaClick"
            />
        </template>
    </ui-modal>
</template>

<script>
export default {
    computed: {
        modalArgs() {
            return this.$store.getters.modalState.args
        },
        isSuccess() {
            return this.modalArgs.isSuccess
        },
        operator() {
            return this.modalArgs.operator
        }
    },

    methods: {
        onCtaClick() {
            if (!this.isSuccess) {
                const { id, name, code } = this.operator

                this.$store.dispatch('openModal', {
                    componentPath: 'drs/operators/OperatorContract',
                    args: {
                        selectedOperator: { id, name, code }
                    }
                })
                return
            }

            this.$store.dispatch('openModal', {
                componentPath: 'drs/operators/ContractLocations',
                args: { ...this.modalArgs }
            })
        }
    }
}
</script>